import type React from 'react'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { LoginForm } from '../components/auth/LoginForm'
import { theme } from '../theme/theme'

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${theme.spacing.md};
`

const SignupPage: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const role = searchParams.get('role') as 'coach' | 'athlete' | null

  // Redirect to role selection if no role is provided
  useEffect(() => {
    if (!role || (role !== 'coach' && role !== 'athlete')) {
      navigate('/role-selection')
    }
  }, [role, navigate])

  if (!role) {
    return null
  }

  return (
    <PageContainer>
      <LoginForm isSignUp={true} role={role} onToggleMode={() => navigate('/login')} />
    </PageContainer>
  )
}

export default SignupPage
